import { accountGetters } from "./account/getters";
import { checkModulePermission, checkSubmenuPermission } from "../../router/guard";
import { isDevOrLocal, isStaging } from "../../services/http/http-client";
import { dtGPTGetters } from "./dtgpt/getters";

export const getters = {
  ...accountGetters,
  ...dtGPTGetters,
  appDrawer: (state) => state.drawer,
  // reportTabs: (state) => {
  //   return state.appNavItems.find(a => a.route == 'distribution').children(c => c.route === 'reports')
  // },
  appNavItems: (state) => {
    return state.appNavItems
      // .filter(e => {
      //   if (isStaging()) {
      //     // The Following Turns Off Distribution in Staging Environment
      //     // if (['distribution'].includes(e.route)) {
      //     //   return false;
      //     // }
      //     // else {
      //     //   return true;
      //     // }
      //     return true;
      //   }
      //   else if (!isDevOrLocal()) {
      //     if (['catalog', 'royalty', 'licencing', 'distribution'].includes(e.route)) {
      //       return false;
      //     }
      //     else {
      //       return true;
      //     }
      //   }

      //   else {
      //     return true;
      //   }
      // })
      .map(moduleNavItem => {
        if (moduleNavItem.children && moduleNavItem.children.length > 0) {
          return {
            ...moduleNavItem,
            children: moduleNavItem.children.filter(subMenuNavItem => {
              if (checkSubmenuPermission(moduleNavItem['route'], subMenuNavItem['route'])) {
                return true;
              } else {
                return false;
              }
            })
          };
        } else {
          return moduleNavItem;
        }
      })
      .filter(moduleNavItem => {
        if (checkModulePermission(moduleNavItem['route'])) {
          return true;
        } else {
          return false;
        }
      });
  },
  getBreadcrumbs: (state) => {
    return (path) => {
      const params = path.split('/').filter((e) => e.length > 0);

      const main = state.appNavItems.find((e) => e.route === params[0]);
      const sub = main.children.find((e) => e.route === params[1]);

      return [main.title.toUpperCase(), sub.title];
    };
  },
  mainNavActive: (state) => state.mainNavActive,
  systemLanguages: (state) => {
    return state.systemLanguages;
  },
  systemLanguage: (state) => {
    return {
      text: state.systemLanguage.language,
      value: state.systemLanguage.locale
    };
  },
  systemLanguagesTV: (state) => {
    return [
      ...state.systemLanguages.map(e => ({
        text: e.language,
        value: e.locale
      })),
      ...[
        window.location.origin == "https://dev.berlin3.com" ||
          window.location.origin == "http://localhost:8080"
          ? {
            text: "Devmode keys",
            value: "keys",
          }
          : {},
      ],
    ];
  },

  // Login Getters

  loginUser: (state) => state.loginUser,
  loginRedirectRoute: state => state.loginRedirectRoute,
};
function systemLanguages(systemLanguagesTV) {
  return systemLanguagesTV.map(s => {
    return {
      text: this.$dft.capHead(this.$t(s.text)),
      value: s.value
    }
  })
}